import React from 'react'
import cn from 'classnames'
import classes from '../../Table.module.scss'

export const PlanName = ({
  isSelected,
  children,
  spacing = 4,
}: {
  isSelected?: boolean
  children: React.ReactNode
  spacing?: number
}) => (
  <div
    role='columnheader'
    className={cn(
      `col-${spacing}`,
      'd-flex mc-text--center justify-content-center align-items-center mc-text-h6',
      {
        [classes.selected]: isSelected,
      },
    )}
    aria-current={isSelected}
  >
    <p className='mc-mt-7 mc-mb-2'>{children}</p>
  </div>
)
